/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpContextToken,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { APIEnvelope } from '../models/api'
import { formatAsUTC, tzDate } from '../utilities/date'

export const PARSE_DATE_PROPS = new HttpContextToken<string[]>(() => [])

export class DateInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const newReq = req.body && !(req.body instanceof FormData) ? req.clone({
      body: this.sanitizeBody(req.body),
    }): req

    return next.handle(newReq).pipe(
      map((res) => {
        if (
          res.type !== HttpEventType.Response || // not even a response
          !res.ok || // error
          !res.body || // strange shape
          !(res.body as any).results || // strange shape
          !((res.body as any).results as any).length // no results to transform
        ) {
          // do nothing
          return res
        }

        return res.clone({
          body: {
            ...res.body,
            results: (res.body as APIEnvelope<any>).results.map((item) =>
              newReq.context.get(PARSE_DATE_PROPS).reduce(
                (acc, key) => ({
                  ...acc,
                  [key]: this.asDate(acc[key]),
                }),
                item,
              ),
            ),
          } as APIEnvelope<any>,
        })
      }),
    )
  }

  asDate(v: any) {
    if (!v || typeof v !== 'string') {
      return v
    }
    const paddedString = /^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T05:00:00`: v
    const sanitizedDateStr = paddedString.replace(' ', 'T').replace(/[.Zz].*$/, '')
    const date = tzDate(sanitizedDateStr, '+00')
    return date
  }

  sanitizeBody(body: any): any {
    if(!body) {
      return body
    }
    
    if(typeof body === 'object' && body instanceof Date) {
      return formatAsUTC(body)
    }

    if(typeof body === 'object' && Array.isArray(body)) {
      return body.map(b => this.sanitizeBody(b))
    }

    if(typeof body === 'object') {
      return Object.entries(body).reduce((acc, [k,v]) => ({
        ...acc,
        [k]: this.sanitizeBody(v),
      }), {})
    }

    else {
      return body
    }
  }
}
